// extracted by mini-css-extract-plugin
export default {"tripCalculationAmount":"style_tripCalculationAmount__njL2y"};